/**
 * @module cercaliagl/view/VDropDownMultiple
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView from './BaseView';
/**
 * @typedef {Object} Item
 * @property {string} id
 * @property {string} value
 * @property {string} iconName
 * @property {string[]} paths
 * @property {function() : void} enableOption
 * @property {function() : void} disableOption
 */
/**
 * @enum {string}
 */
export var EventType = {
    SELECTED: 'select',
    DESELECTED: 'deselect',
};
/**
 * @classdesc
 *
 */
var VDropDownMultiple = /** @class */ (function (_super) {
    __extends(VDropDownMultiple, _super);
    /**
     * @constructor
     */
    function VDropDownMultiple() {
        var _this = this;
        var jqElement = $('<div class="v-drop-down-multiple mdc-elevation--z4"><ul class="mdc-list collection"/></div>');
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {Object.<string, JQuery>}
         */
        _this.items_ = {};
        /**
         * @private
         * @type {number}
         */
        _this.elementsSelected_ = 0;
        return _this;
    }
    /**
     * @param {Item} item Item
     */
    VDropDownMultiple.prototype.add = function (item) {
        var _this = this;
        this.items_[item.id] = $("\n      <li href=\"#!\" data-id=\"".concat(item.id, "\" class=\"mdc-list-item collection-item\">\n        <span class=\"mdc-list-item__text\">").concat(item.value, "</span>\n        ").concat(item.iconName ? "<span class=\"".concat(item.iconName, "\"></span>") : '', "\n      </li>"))
            .on('click', function () {
            var elementCurrentlyEnabled = _this.items_[item.id].hasClass('mdc-list-item--activated');
            if (!elementCurrentlyEnabled) {
                _this.selectItem(item.id);
                _this.eventEmitter_.emit(EventType.SELECTED, item);
            }
            else {
                _this.deselectItem(item.id);
                _this.eventEmitter_.emit(EventType.DESELECTED, item);
            }
        })
            .appendTo(this.jqElement_.find('ul'));
        if (item.paths) {
            item.paths.forEach(function (path) { return _this.jqElement_.find(".".concat(item.iconName)).append("<span class=\"".concat(path, "\"/>")); });
        }
    };
    /**
     * @param {string} id Id
     * Selects an item
     * @api
     */
    VDropDownMultiple.prototype.selectItem = function (id) {
        this.jqElement_.find("li[data-id=".concat(id, "]")).addClass('mdc-list-item--activated');
        this.elementsSelected_ += 1;
    };
    /**
     * @param {string} id Id
     * Deselects an item
     * @api
     */
    VDropDownMultiple.prototype.deselectItem = function (id) {
        this.jqElement_.find("li[data-id=".concat(id, "]")).removeClass('mdc-list-item--activated');
        this.elementsSelected_ -= 1;
    };
    /**
     * @param {string} id Id
     * Removes an item
     * @api
     */
    VDropDownMultiple.prototype.remove = function (id) {
        this.jqElement_.remove(this.items_[id]);
        delete this.items_[id];
    };
    /**
     * @return {number} Number of elements selected
     * @api
     */
    VDropDownMultiple.prototype.getNumberOfElementsSelected = function () {
        return this.elementsSelected_;
    };
    return VDropDownMultiple;
}(BaseView));
export default VDropDownMultiple;
//# sourceMappingURL=VDropDownMultiple.js.map